import * as React from 'react';
import LensIcon from '../assets/images/lens.svg';
import './EmptyOfficesView.scss';

interface IStateProps {
	message?: string;
}

export const EmptyOfficesView: React.FC<IStateProps> = ({ message }) => {
	return (
		<div className='edl-empty-list-container'>
			<img className='edl-empty-list-lens' src={LensIcon} alt="magnifier"/>
			<div className='edl-empty-list-text'>
				{message}
			</div> 
		</div> 
    )
};
